<af-main-container [title]="'i18n_af_refunds' | translate"
                   [showBreadcrumbs]="false"
                   [showBackButton]="false">
    <mat-tab-group mat-align-tabs="start" animationDuration="0"
                   class="mt-16 w-100 h-100 hide-scroll-bar"
                   [(selectedIndex)]="selectedTabIndex"
                   (selectedIndexChange)="handleNavigation($event)">
        @for (tab of tabs; track tab) {
            <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                <ng-template matTabContent>
                    @if (activeTab === tab) {
                        <af-full-table class="w-100 h-100"
                                       [filterFields]="filterFields"
                                       [showImport]="false"
                                       [showExport]="false"
                                       [dataSource]="dataSource"
                                       (tableUpdateListener)="loadRefunds($event)"
                                       [columnTranslationPrefixes]="{id: 'refunds', status:'refunds'}"
                                       (emptyStateClickListener)="navigateToIncidents()"
                                       [totalElements]="filterHolderService.getState(activeTab)?.response?.total"
                                       [filterEvent]="filterHolderService.getState(activeTab)?.tableEvent.filter"
                                       [pageEvent]="filterHolderService.getState(activeTab)?.tableEvent.page"
                                       emptyStateIconName="ic_empty_state_no_refunds"
                                       emptyStateTitleTranslationKey="i18n_af_emptyStateTitleRefundsNotCreated"
                                       emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleAllRefundsNotCreated"
                                       emptyStateButtonLabel="i18n_af_buttonGoToIncidents"
                                       totalElementsTranslationKey="i18n_af_labelTotalElementsRefunds"
                                       placeholderContext="refunds"/>
                    }
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</af-main-container>
